export const TypesAvarias = {
    AVARIAS: "AVARIAS",
    ADD_AVARIAS: "ADD_AVARIAS",
    REMOVE_AVARIAS: "REMOVE_AVARIAS",
    AVARIA_LOCAL_CHECKED: "AVARIA_LOCAL_CHECKED",
    AVARIA_TIPO_CHECKED: "AVARIA_TIPO_CHECKED",
    AVARIA_COMPLEMENTO_CHECKED: "AVARIA_COMPLEMENTO_CHECKED",
    AVARIA_REMOVER_CHECKED: "AVARIA_REMOVER_CHECKED",
    RESET: "RESET"
}

const INITIAL = {
    $id: 0,
    Sucesso: false,
    Mensagem: "",
    TiposAvaria: [],
    LocaisAvaria: [],
    ComplementosAvaria: [],
    Avarias: [],
    avariaLocalChecked: [],
    avariaTipoChecked: [],
    avariaComplementoChecked: [],
    avariaRemoverChecked: []
}

export default function avariasReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesAvarias.AVARIAS:
            return {
                ...state,
                $id: action.payload.$id,
                Sucesso: action.payload.Sucesso,
                Mensagem: action.payload.Mensagem,
                TiposAvaria: action.payload.TiposAvaria,
                LocaisAvaria: action.payload.LocaisAvaria,
                ComplementosAvaria: action.payload.ComplementosAvaria,
                Avarias: action.payload.Avarias
            };
        case TypesAvarias.ADD_AVARIAS:
            return {
                ...state,
                // Avarias: [...state.Avarias, ...action.payload]
                Avarias: action.payload
            };
        case TypesAvarias.AVARIA_LOCAL_CHECKED:
            return {
                ...state,
                avariaLocalChecked: action.payload
            };
        case TypesAvarias.AVARIA_TIPO_CHECKED:
            return {
                ...state,
                avariaTipoChecked: action.payload
            };
        case TypesAvarias.AVARIA_COMPLEMENTO_CHECKED:
            return {
                ...state,
                avariaComplementoChecked: action.payload
            };
        case TypesAvarias.AVARIA_REMOVER_CHECKED:
            return {
                ...state,
                avariaRemoverChecked: action.payload
            };
        case TypesAvarias.REMOVE_AVARIAS:
            return ({
                ...state,
                Avarias: [...state.Avarias.filter(function (a) { return !action.payload.includes(a.AvariaDescricao) })]
            })
        case TypesAvarias.RESET:
            return INITIAL;

        default:
            return state;
    }
}

export const AvariasActions = {
    getAvarias,
    addAvarias,
    deletarAvarias,
    resetState,
    avariaLocalChecked,
    avariaTipoChecked,
    avariaComplementoChecked,
    avariaRemoverChecked
}

function getAvarias(dadosAvarias) {
    return {
        type: TypesAvarias.AVARIAS,
        payload: dadosAvarias
    }
}

function avariaLocalChecked(checked) {
    return {
        type: TypesAvarias.AVARIA_LOCAL_CHECKED,
        payload: checked
    }
}

function avariaTipoChecked(checked) {
    return {
        type: TypesAvarias.AVARIA_TIPO_CHECKED,
        payload: checked
    }
}

function avariaComplementoChecked(checked) {
    return {
        type: TypesAvarias.AVARIA_COMPLEMENTO_CHECKED,
        payload: checked
    }
}

function avariaRemoverChecked(checked) {
    return {
        type: TypesAvarias.AVARIA_REMOVER_CHECKED,
        payload: checked
    }
}

function addAvarias(dadosAvarias) {
    return {
        type: TypesAvarias.ADD_AVARIAS,
        payload: dadosAvarias
    }
}

function deletarAvarias(avaria) {

    let avariasDescricaoRemover = [];

    avaria.forEach(element => {
        avariasDescricaoRemover.push(element[0]);
    });

    return {
        type: TypesAvarias.REMOVE_AVARIAS,
        payload: avariasDescricaoRemover
    }
}

function resetState() {
    return { type: "RESET" }
}
